import { fill } from './fill.js'
import { KindergartenFinal2023 as Page } from './Page.jsx'
import templateUrl from './template.pdf'

export default {
  key: 'kindergarten_final_2023_09',
  label: 'Kindergarten Communication of Learning — Final Observations',
  templateUrl,
  fill,
  Page,
}
